import { marked } from "marked";

import { Html } from "@/components/html/html";

marked.setOptions({ smartLists: true });

const Markdown = ({ content }: { content: string }) => {
  return <Html content={marked(content)} />;
};

export default Markdown;
